import(/* webpackMode: "eager", webpackExports: ["LegacyHomepage"] */ "/repo/apps/web/src/components/legacy-homepage/LegacyHomepage.tsx");
